export const operationMenuList = [
      {
            rowName: 'Orders',
            rowIcon: '../../../../assets/menu-icon/IconCart.svg',
            childMenuList: [
                  {
                        label: 'Purchase Order',
                        route: '/NewPurchaseOrder',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PO_DETAILS'
                  },
                  {
                        label: 'Return Purchase Order',
                        route: '/po_returnPurchaseOrder',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PRO_DETAILS'
                  },
                  {
                        label: 'Sales Order',
                        route: '/so_Orders',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_ORDERS'
                  },
                  {
                        label: 'Return Sales Order',
                        route: '/so_ReturnOrder',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_RETURNORDER'
                  },


                  {
                        label: 'Allocation Rule',
                        route: '/order-allocation-rule',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'so_OrderAllocationRule'
                  },
                  {
                        label: 'Point Of Sale',
                        route: '/point-of-sale',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'so_PointOfSale'
                  }
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "PO_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "PRO_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "SO_ORDERS" },
                  { "rightcode": "VIEW", "screencode": "SO_RETURNORDER" },
                  { "rightcode": "VIEW", "screencode": "SO_STOCKTRANSFER" },
                  { "rightcode": "VIEW", "screencode": "MWL_WAREHOUSELOCATIONMASTER" },
                  { "rightcode": "VIEW", "screencode": "AirShipment_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "so_OrderAllocationRule" },
            ])
      },
      {
            rowName: 'Inventory',
            rowIcon: '../../../../assets/menu-icon/IconInventory.svg',
            childMenuList: [
                  // Added by priya - 02/07/2026 - cn(PRIYA-JUL-003)
                  {
                        label: 'Gate Management',
                        route: '/GateManagement',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'GateManagement_Details'
                  },
                  // End by priya
                  {
                        label: 'Goods Inward',
                        route: '/GoodsInward',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'GI_DETAILS'
                  },
                  // {
                  //       label: 'Put Away',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  {
                        label: 'Goods Outward',
                        route: '/so_GoodsOutward',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'GO_DETAILS'
                  },
                  //Add by burhan - 14-Jan-2026
                  {
                        label: 'Packaging',
                        route: '/packaging',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'GO_PACKAGING'
                  },
                  //End by burhan - 14-Jan-2026
                  {
                        label: 'Stock Transfer',
                        route: '/so_StockTransfer',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_STOCKTRANSFER'
                  },
                  {
                        label: 'Kit Work Order',
                        route: '/so_KitWorkOrder',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_KITWORKORDER'
                  },
                  {
                        label: 'Dispatch',
                        route: '/so_dis_dispatch',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_DIS_DISPATCH_DETAILS'
                  },
                  {
                        label: 'Shipment',
                        route: '/order_LTL',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'ORDER_LTL_DETAILS'
                  },
                  {
                        label: 'Stock Management',
                        route: '/so_StockManagement',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_STOCKMANAGEMENTMODULE'
                  },
                  {
                        label: 'Warehouse Location',
                        route: '/mwl_warehouseLocationMaster',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'MWL_WAREHOUSELOCATIONMASTER'
                  },
                  {
                        label: 'Print Label',
                        route: '/print_label',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PRINT_LABEL'
                  },
                  {
                        label: 'Stock Taking',
                        route: '/StockTaking',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'StockTaking_Details'
                  },
                  {
                        label: 'Product Reorder',
                        route: '/so_prd_ProductReorder',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_PRD_PRODUCTREORDER_DETAILS'
                  },
                  //added by BURHAN - 31-May-2026
                  {
                        label: 'Replenishment',
                        route: '/BinReplenishment',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SO_PRD_PRODUCTREORDER_DETAILS'
                  },
                  //end by BURHAN
                  // {
                  //       label: 'Picking',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  // {
                  //       label: 'Dispatch',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  // {
                  //       label: 'Kit Order',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  // {
                  //       label: 'Stock Transfer',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
                  // {
                  //       label: 'Stock Take',
                  //       route: '/',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BYVEHICLE_DETAILS'
                  // },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "GI_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "GO_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "SO_STOCKTRANSFER" },
                  { "rightcode": "VIEW", "screencode": "SO_DIS_DISPATCH_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "SO_STOCKMANAGEMENTMODULE" },
                  { "rightcode": "VIEW", "screencode": "MWL_WAREHOUSELOCATIONMASTER" },
                  { "rightcode": "VIEW", "screencode": "PRINT_LABEL" },
                  { "rightcode": "VIEW", "screencode": "StockTaking_Details" },
                  { "rightcode": "VIEW", "screencode": "ORDER_LTL_DETAILS" },
            ])
      },
      {
            rowName: 'Shipment',
            rowIcon: '../../../../assets/menu-icon/Iconrequest.svg',
            childMenuList: [
                  {
                        label: 'FTL - Point To Point',
                        route: '/FtlList',
                        isSubChild: false,
                        // subChildMenuList: [
                        //       {
                        //             label: 'Sub Menu',
                        //       },
                        //       {
                        //             label: 'Sub Menu2',
                        //       }
                        // ],
                        rightcode: 'VIEW',
                        screencode: 'FTL_DETAILS'
                  },
                  {
                        label: 'FTL - Container Movement',
                        route: '/Container-Movement',
                        isSubChild: false,
                        rightcode: 'VIEW',
                        screencode: 'FTLContainerMovement_DETAILS'
                  },
                  {
                        label: 'FTL - Port Movement',
                        route: '/OpsDMRReport',
                        isSubChild: false,
                        rightcode: 'VIEW',
                        screencode: 'FTLPortMovement_DETAILS'
                  },
                  //added by vithu 19-03-2025
                  {
                        label: 'LTL - Shipment',
                        route: '/FtlList?Type=LTL',
                        isSubChild: false,
                        rightcode: 'VIEW',
                        screencode: 'LTL_SHIPMENT'
                  },
                  {
                        label: 'Route Optimization',
                        route: '/FtlList?Type=RouteOptimizer',
                        isSubChild: false,
                        rightcode: 'VIEW',
                        screencode: 'ROUTE_OPTIMIZATION_SHIPMENT'
                  },
                  // {
                  //       label: 'Planning',
                  //       route: '/NewPlanning',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'AirShipment_DETAILS'
                  // },
                  // {
                  //       label: 'Shipment',
                  //       route: '/order_LTL',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'ORDER_LTL_DETAILS'
                  // },
                  // {
                  //       label: 'Air Shipments',
                  //       route: '/NewBookingList',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'AirShipment_DETAILS'
                  // },
                  // {
                  //       label: 'Part Truck Load',
                  //       route: '',
                  //       isSubChild: true,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Container Movement',
                  //       route: '',
                  //       isSubChild: true,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Courier',
                  //       route: '/new-courier',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'BY_COURIER'
                  // },
                  {
                        label: 'Bidding Request',
                        route: '/Bid-Request',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'BIDDING_REQUEST'
                  },
                  {
                        label: 'Trips',
                        route: '/New-Trips',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SHIPMENT_TRIPS'
                  },
                  // Added by priya - 05/02/2026 - cn(PRIYA-JAN26-017)
                  {
                        label: 'EwayBill Log Detail',
                        route: '/EwayBillLogDetail',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: ''
                  },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "FTL_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "AirShipment_DETAILS" },
                  // { "rightcode": "VIEW", "screencode": "ORDER_LTL_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "FTLContainerMovement_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "LTL_SHIPMENT" },
                  { "rightcode": "VIEW", "screencode": "ROUTE_OPTIMIZATION_SHIPMENT" },
                  // { "rightcode": "VIEW", "screencode": "ORDER_LTL_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "BIDDING_REQUEST" },
                  { "rightcode": "VIEW", "screencode": "SHIPMENT_TRIPS" },
            ])
      },
      // {
      //       rowName: 'Planning',
      //       rowIcon: '../../../../assets/menu-icon/Iconplanning.svg',
      //       childMenuList: [
      //             {
      //                   label: 'View Trips',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Trip Planning',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Route Optimization',
      //                   route: '/trip-planning-map',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: 'ROUTE_OPTIMIZATION'
      //             },

      //       ],
      //       rightsList: []
      // },
      // {
      //       rowName: 'Execution',
      //       rowIcon: '../../../../assets/menu-icon/Iconexecution.svg',
      //       childMenuList: [
      //             {
      //                   label: 'Assign Vehicle',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Pickup',
      //                   route: '',
      //                   isSubChild: true,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Active Trip',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Completed Trips',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Cancelled Trips',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },

      //       ],
      //       rightsList: []
      // },
      // {
      //       rowName: 'Visibility & Control',
      //       rowIcon: '../../../../assets/menu-icon/Iconvisibility.svg',
      //       childMenuList: [
      //             {
      //                   label: 'Analytics',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Live Tracking',
      //                   route: '/VehicleTracking',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Communication',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Alerts',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Calendar',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Rate Check',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //             {
      //                   label: 'Attachments',
      //                   route: '',
      //                   isSubChild: false,
      //                   subChildMenuList: [],
      //                   rightcode: 'VIEW',
      //                   screencode: ''
      //             },
      //       ],
      //       rightsList: []
      // },
      {
            rowName: 'Fleet Management',
            rowIcon: '../../../../assets/menu-icon/Iconfeet-management.svg',
            childMenuList: [
                  {
                        label: 'Drivers',
                        route: '/NewDriver',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'DRIVERS_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'Vehicles',
                        route: '/NewVehicleMaster',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'VEHICLES_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'Tyres',
                        route: '',
                        isSubChild: true,
                        subChildMenuList: [
                              {
                                    label: 'Tyre List',
                                    route: '/NewTyreList',
                                    rightcode: 'VIEW',
                                    screencode: 'TYRELIST_DETAILS'
                              },
                              {
                                    label: 'Retreading',
                                    route: 'NewTyreRetreading',
                                    rightcode: 'VIEW',
                                    screencode: 'RETREADING_DETAILS'
                              },
                              {
                                    label: 'Repairs',
                                    route: 'NewTyreRepair',
                                    rightcode: 'VIEW',
                                    screencode: 'REPAIRS_DETAILS'
                              },
                              {
                                    label: 'Assign',
                                    route: 'NewTyreAssign',
                                    rightcode: 'VIEW',
                                    screencode: 'ASSIGN_DETAILS'
                              },
                              {
                                    label: 'Discard',
                                    route: 'NewTyreDiscard',
                                    rightcode: 'VIEW',
                                    screencode: 'DISCARD_DETAILS'
                              }
                        ],
                        rightcode: 'VIEW',
                        screencode: 'TYRES_DETAILS',
                        rightsList: JSON.stringify([
                              { "rightcode": "VIEW", "screencode": "TYRELIST_DETAILS" },
                              { "rightcode": "VIEW", "screencode": "RETREADING_DETAILS" },
                              { "rightcode": "VIEW", "screencode": "REPAIRS_DETAILS" },
                              { "rightcode": "VIEW", "screencode": "ASSIGN_DETAILS" },
                              { "rightcode": "VIEW", "screencode": "DISCARD_DETAILS" }
                        ])
                  },
                  {
                        label: 'Repairs & Maintenance',
                        route: 'NewRepairMaintenance',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'REPAIRSMAINTENANCE_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'Vehicle Inspection',
                        route: 'NewVehicleInspection',
                        // route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'VEHICLEINSPECTION_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'Reminders',
                        route: '',
                        isSubChild: true,
                        subChildMenuList: [
                              {
                                    label: 'Service',
                                    route: 'ServiceReminders',
                                    rightcode: 'VIEW',
                                    screencode: 'SERVICE_DETAILS'
                              },
                              {
                                    label: 'Renewal',
                                    route: 'RenewalReminders',
                                    rightcode: 'VIEW',
                                    screencode: 'RENEWAL_DETAILS'
                              },
                              {
                                    label: 'Task Type',
                                    route: 'TaskTypeReminders',
                                    rightcode: 'VIEW',
                                    screencode: 'TASKTYPE_DETAILS'
                              }
                        ],
                        rightcode: 'VIEW',
                        screencode: 'REMINDERS_DETAILS',
                        rightsList: []
                  },
                  {
                        label: 'E-Challan',
                        route: '/EChallan',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'EChallan_DETAILS',
                        rightsList: []
                  },
                  // Added by priya - 13/01/2026 - CN(PRIYA-JAN26-010)
                  {
                        label: 'Toll Plaza',
                        route: '/TollPlaza',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'TollPlaza_Details', // Added by priya - 13/08/2026 - cn(PRIYA-AUG26-010)
                        rightsList: []
                  },

                  //Add by Burhan - Yash's PC - 29-Jan-2026
                  {
                        label: 'Fastag',
                        route: '/Fastag',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'Fastag_DETAILS',
                        rightsList: []
                  },
                  //end by BURHAN
                  // {
                  //       label: 'Assets',
                  //       route: '/Assets',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'Assets_DETAILS',
                  //       rightsList: []
                  // },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "DRIVERS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "VEHICLES_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "REPAIRSMAINTENANCE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "VEHICLEINSPECTION_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "REMINDERS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "TYRES_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "EChallan_DETAILS" },
            ])
      },
      {
            rowName: 'Reports',
            rowIcon: '../../../../assets/menu-icon/IconReports.svg',
            childMenuList: [
                  {
                        label: 'Orders',
                        route: '/NewOrdersReports',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'OPERATIONSREPORTS_DETAILS'
                  },
                  {
                        label: 'Accounts',
                        route: '/AccountReports',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'ACCOUNTREPORTS_DETAILS'
                  },
                  {
                        label: 'Operations',
                        route: '/NewOperationalReports',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'ACCOUNTREPORTS_DETAILS'
                  },
                  {
                        label: 'Transportation',
                        route: '/Transportation_Report',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'TRANSPORTATIONREPORT_DETAILS'
                  },
                  {
                        label: 'Finance',
                        route: '',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'FINANCEREPORT_DETAILS'
                  },
                  {
                        label: 'Inventory',
                        route: '/InventoryReport',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'INVENTORYREPORT_DETAILS'
                  },
                  {
                        label: 'Masters',
                        route: '/Masters',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'Masters_DETAILS'
                  },
                  {
                        label: 'Fleets',
                        route: '/FleetReports',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'FleetReports_DETAILS'
                  },

            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "OPERATIONSREPORTS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "ACCOUNTREPORTS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "TRANSPORTATIONREPORT_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "FINANCEREPORT_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "INVENTORYREPORT_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "Masters_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "FleetReports_DETAILS" }
            ])
      },

      // added by yash 29-04-2026
      {
            rowName: 'Utility',
            rowIcon: '../../../../assets/menu-icon/IconUtility.svg',

            childMenuList: [
                  {
                        label: 'Notes',
                        route: '/global-notes',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'NOTES_MODULE'
                  },
                  //added by BURHAN - 24-July-2026
                  {
                        label: 'Salesman Tracking',
                        route: '/Salesman',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SALESMAN_DETAILS',
                        rightsList: []
                  },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "NOTES_MODULE" }
            ])
      }
      // end by yash 29-04-2026
]

export const BookOfAccountsMenuList = [
      {
            rowName: 'Accounting',
            rowIcon: '../../../../assets/menu-icon/Iconrequest.svg',
            childMenuList: [
                  // {
                  //       label: 'Pending Trips for Invoice',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  {
                        label: 'Generate Invoice',
                        route: 'pending-invoice-consignment',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PENDINGCONSIGNMENTS_DETAILS'
                  },
                  {
                        label: 'Sales Invoice',
                        route: 'sales-invoice-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SALESINVOICE_DETAILS'
                  },
                  {
                        label: 'Generate Bills',
                        route: 'pending-purchase-bill',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PENDING_BILLS'
                  },
                  {
                        label: 'Purchase Bill',
                        route: 'purchase-bills',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'EXPENSES_DETAILS'
                  },
                  {  //added by fahim 02-03-2026
                        label: 'Journal Entry',
                        route: 'new-journal-entry',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'JOURNALENTRY_DETAILS'
                  },
                  // {
                  //       label: 'Pending Trips for Billing',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Purchase Invoice',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Wallet',
                  //       route: '/Wallet',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: 'WALLET_DETAILS'
                  // },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "PENDINGCONSIGNMENTS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "SALESINVOICE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "PENDING_BILLS" },
                  { "rightcode": "VIEW", "screencode": "EXPENSES_DETAILS" },
            ])
      },
      {
            rowName: 'Bank & Cash',
            rowIcon: '../../../../assets/menu-icon/Iconplanning.svg',
            childMenuList: [
                  {
                        // Sales Payment Request 
                        label: 'Advance Receipt From Customer', // changed by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
                        route: '/new-payment-req-sales',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PAYMENTREQUEST_SALES'
                  },
                  {
                        label: 'Payment Received From Customer', // changed by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
                        route: '/new-payment-received',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PAYMENTRECEIVED_DETAILS'
                  },
                  {
                        // Purchase Bill Payment Request 
                        label: 'Advance Payment To Transporter/Driver', // changed by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
                        route: '/NewPaymentReq',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PAYMENTREQUEST_PURCHASE'
                  },
                  {
                        label: 'Payment Made To Transporter/Driver/Vendor', // changed by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
                        route: '/new-payment-made',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PAYMENTMADE_DETAILS'
                  },
                  {
                        label: 'Cash Receipts',
                        route: '/new-cash-receipt',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'CASH_RECEIPTS'
                  },
                  {
                        // Purchase Bill Payment Request 
                        label: 'Cash Expense',
                        route: '/cash-expense',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'CASH_EXPENSE'
                  },
                  // {
                  //       label: 'Cash Receipts',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Advance Payments',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Payments',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },

                  // {
                  //       label: 'Payment Schedule',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Cash Expense',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },
                  // {
                  //       label: 'Bank Statement',
                  //       route: '',
                  //       isSubChild: false,
                  //       subChildMenuList: [],
                  //       rightcode: 'VIEW',
                  //       screencode: ''
                  // },

            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "PAYMENTRECEIVED_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "PAYMENTMADE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "PAYMENTREQUEST_SALES" },
                  { "rightcode": "VIEW", "screencode": "PAYMENTREQUEST_PURCHASE" },
                  { "rightcode": "VIEW", "screencode": "CASH_RECEIPTS" },
                  { "rightcode": "VIEW", "screencode": "CASH_EXPENSE" }
            ])
      },
]

export const SettingMenuList = [
      {
            rowName: 'Accounts',
            rowIcon: '../../../../assets/menu-icon/Iconrequest.svg',
            childMenuList: [
                  {
                        label: 'Chart of Accounts',
                        route: '/NewChartOfAccounts',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'CHARTOFACCOUNT_DETAILS'
                  },
                  {
                        label: 'Opening Balance',
                        route: '/opening-balance-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'OPENINGBALANCE_DETAILS'
                  },
                  {
                        label: 'Accounting Period',
                        route: '/accounting-period-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'ACCOUNTINGPERIOD_DETAILS'
                  },
                  {
                        label: 'Manage Taxes',
                        route: '/NewManageTaxes',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'MANAGETAXES_DETAILS'
                  },
                  {
                        label: 'Manage Cess',
                        route: '/NewManageCess',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'MANAGETAXES_DETAILS'
                  },
                  {
                        label: 'Manage Exemptions',
                        route: '/NewTaxExemptionsModule',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'TAXEXEMPTIONS_DETAILS'
                  },
                  {
                        label: 'Manage TDS',
                        route: '/NewManageTds',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'MANAGETDS_DETAILS'
                  },
                  {
                        label: 'Invoice Type',
                        route: '/new-invoice-type',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'CHARGETYPE_DETAILS'
                  },
                  {
                        label: 'Charges',
                        route: '/charges-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'CHARGE_DETAILS'
                  },
            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "CHARTOFACCOUNT_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "OPENINGBALANCE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "ACCOUNTINGPERIOD_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "MANAGETAXES_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "TAXEXEMPTIONS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "MANAGETDS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "CHARGETYPE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "CHARGE_DETAILS" }
            ])
      },
      {
            rowName: 'Masters',
            rowIcon: '../../../../assets/menu-icon/Iconplanning.svg',
            childMenuList: [
                  {
                        label: 'Settings',
                        route: '/NewSettings',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'SETTINGS_DETAILS'
                  },
                  {
                        label: 'Network',
                        route: '/NewNetwork',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'NETWORK_DETAILS'
                  },
                  {
                        label: 'Business Category',
                        route: '/new-business-category',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'BusinessCategory_DETAILS'
                  },
                  {
                        label: 'Product Category',
                        route: '/business-new',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'ProductCategory_DETAILS'
                  },
                  // Added by priya - 19/09/2025
                  {
                        label: 'Declaration Category',
                        route: '/declaration-category',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'DeclarationCategory_DETAILS'
                  },
                  // end
                  {
                        label: 'Products',
                        route: '/new-products',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'PRODUCTS_DETAILS'
                  },
                  {
                        label: 'Fuel Price',
                        route: '/newfuel',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'FUELPRICE_DETAILS'
                  },
                  {
                        label: 'Fuel Pump',
                        route: '/newfuelpricepumpwise',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'FUELPUMP_DETAILS'
                  },
                  {
                        label: 'Target',
                        route: '/new-target',
                        isSubChild: false,
                        subChildMenuList: [],
                        rightcode: 'VIEW',
                        screencode: 'TARGET_DETAILS'
                  },

            ],
            rightsList: JSON.stringify([
                  { "rightcode": "VIEW", "screencode": "SETTINGS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "NETWORK_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "BYVEHICLE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "PRODUCTS_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "FUELPRICE_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "FUELPUMP_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "ProductCategory_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "TARGET_DETAILS" },
                  { "rightcode": "VIEW", "screencode": "BusinessCategory_DETAILS" },
            ])
      },

]

export const NavMenus = [
      { header: 'Operations', list: operationMenuList },
      { header: 'Books of Accounts', list: BookOfAccountsMenuList },
      { header: 'Settings', list: SettingMenuList }
]